import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useNavigate } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { genresMovies } from '../../Redux/actions/MovieThunk';
import './genre-list.scss';

const GRADIENTS = [
    'linear-gradient(135deg,#3a7bd5,#3a6073)',
    'linear-gradient(135deg,#cc2b5e,#753a88)',
    'linear-gradient(135deg,#56ab2f,#a8e063)',
    'linear-gradient(135deg,#614385,#516395)',
    'linear-gradient(135deg,#f46b45,#eea849)',
    'linear-gradient(135deg,#43cea2,#185a9d)',
    'linear-gradient(135deg,#ff9966,#ff5e62)',
    'linear-gradient(135deg,#11998e,#38ef7d)',
    'linear-gradient(135deg,#c31432,#240b36)',
    'linear-gradient(135deg,#f12711,#f5af19)',
    'linear-gradient(135deg,#DA4453,#89216B)',
    'linear-gradient(135deg,#2980B9,#6DD5FA)',
    'linear-gradient(135deg,#1a1a2e,#16213e)',
    'linear-gradient(135deg,#0f3460,#e94560)',
    'linear-gradient(135deg,#7b2ff7,#f107a3)',
    'linear-gradient(135deg,#009245,#fcee21)',
];

const GenreList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const swiperRef = useRef(null);
    const [genres, setGenres] = useState([]);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const [genreGradients, setGenreGradients] = useState({});

    useEffect(() => {
        dispatch(genresMovies())
            .then(res => { if (res?.content) setGenres(res.content); })
            .catch(() => {});
    }, [dispatch]);

    useEffect(() => {
        fetch('/movies-settings-api.php')
            .then(r => r.json())
            .then(d => {
                if (!d.success) return;
                const row = d.data.find(r => r.setting_key === 'genre_gradients');
                if (row?.setting_value) {
                    try { setGenreGradients(JSON.parse(row.setting_value)); } catch {}
                }
            })
            .catch(() => {});
    }, []);

    const updateNav = (swiper) => {
        setIsBeginning(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
    };

    if (!genres.length) return null;

    return (
        <div className="genre-list">
            {!isBeginning && (
                <button className="gl-nav gl-nav--prev" onClick={() => swiperRef.current?.slidePrev()}>
                    <FaChevronLeft />
                </button>
            )}
            {!isEnd && (
                <button className="gl-nav gl-nav--next" onClick={() => swiperRef.current?.slideNext()}>
                    <FaChevronRight />
                </button>
            )}
            <Swiper
                grabCursor={true}
                spaceBetween={16}
                slidesPerView="auto"
                onSwiper={(s) => { swiperRef.current = s; updateNav(s); }}
                onSlideChange={updateNav}
            >
                {genres.map((g, i) => (
                    <SwiperSlide key={g.id}>
                        <div
                            className="gl-card"
                            style={{ background: genreGradients[g.id] || GRADIENTS[i % GRADIENTS.length] }}
                            onClick={() => navigate(`/search/genre/${encodeURIComponent(g.id)}`)}
                        >
                            <span className="gl-card__name">{g.name}</span>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default GenreList;
